import request from './ajax'

const imUrl = '/api/im/'
// 获取未读消息数量
export const getWaitRead = (data) => request(imUrl + 'wait_read', 'post', { ...data })
